import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { DevicesService } from 'src/app/_services/devices.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{

  diviceXs: boolean;
  diviceSm: boolean;

  slides = [
    { 'image': './assets/img/banner-1.jpg' },
    { 'image': './assets/img/banner-2.jpg' }
  ];

  slidesXs = [
    { 'image': './assets/img/banner-xs-1.jpg' },
    { 'image': './assets/img/banner-xs-2.jpg' }
  ];

  constructor(public mediaObserver: MediaObserver, private devicesService: DevicesService) { }

  ngOnInit() {
    this.devicesService.dievice$.subscribe(res => {
      console.log("device",res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    })
  }



}
